// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_2pRmU","isUploading":"_24c2z","rotate":"_2yGbO","dash":"_2l8vP"};